<template>
  <b-modal
    v-model="aberto"
    title="Entrar como"
    modal-class="entrar-como-modal"
    dialog-class="entrar-como-dialog"
    hide-footer
    @shown="carregarClientes"
  >
    <b-row>
      <b-col cols="4">
        <label for="entrar-como-cliente">Cliente</label>
        <v-select
          input-id="entrar-como-cliente"
          :options="clientes"
          label="text"
          :reduce="item => item.value"
          v-model="clienteEscolhido"
          placeholder="Escolha o cliente"
          @input="carregarUsuarios"
        >
          <div slot="no-options">Nenhum cliente encontrado</div>
        </v-select>
      </b-col>
      <b-col cols="8">
        <label for="entrar-como-usuario">Usuário</label>
        <v-select
          input-id="entrar-como-usuario"
          :options="usuarios"
          label="text"
          :reduce="item => item.value"
          v-model="usuarioEscolhido"
          :disabled="carregandoUsuarios"
          :filterable="true"
          :filter="filtrarUsuario"
          placeholder="Digite para filtrar o usuário"
          @input="entrar"
        >
          <div slot="no-options">Nenhum usuário encontrado</div>
        </v-select>
      </b-col>
    </b-row>
    <div class="mt-3" v-if="testando">
      <b-button variant="outline-secondary" @click="voltar">Voltar às minhas permissões</b-button>
    </div>
  </b-modal>
</template>

<script>
import { userKey } from "@/global";
import { baseApiUrl } from "@/env";
import { titleCase } from "@/config/globalFacilities";
import axios from "axios";
import { mapState } from "vuex";
import "vue-select/dist/vue-select.css";

export default {
  name: "EntrarComoModal",
  props: { value: Boolean },
  data() {
    return {
      clientes: [],
      usuarios: [],
      clienteEscolhido: null,
      usuarioEscolhido: null,
      carregandoUsuarios: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    aberto: {
      get() {
        return this.value;
      },
      set(visivel) {
        this.$emit("input", visivel);
      },
    },
    testando() {
      return Boolean(this.user && this.user.actor_id);
    },
  },
  methods: {
    tipoUsuarioLabel(tipo) {
      if (Number(tipo) === 0) return "serv";
      if (Number(tipo) === 1) return "consig";
      if (Number(tipo) === 2) return "oper";
      return "";
    },
    bancoLabel(consignatario) {
      const bancos = { 1: "Banco do Brasil", 2: "Caixa Econômica", 3: "Bradesco" };
      return bancos[Number(consignatario)] || "";
    },
    filtrarUsuario(options, search) {
      const termo = String(search || "").trim().toLowerCase();
      if (!termo) return options;
      return options.filter((option) => String(option.text || "").toLowerCase().includes(termo));
    },
    carregarClientes() {
      this.usuarioEscolhido = null;
      this.usuarios = [];
      axios.get(`${baseApiUrl}/users/impersonate/clientes`).then((res) => {
        this.clientes = [
          { value: "todos", text: "Todos" },
          ...res.data.map((row) => ({
            value: `${row.cliente}|${row.dominio}`,
            text: titleCase(
              [row.cliente, row.dominio].filter(Boolean).join(" ").replace(/_/g, " ")
            ),
          })),
        ];
        this.clienteEscolhido = "todos";
        this.carregarUsuarios("todos");
      }).catch((error) => {
        const msg = error.response && error.response.data;
        this.$toasted.global.defaultError({ msg: typeof msg === "string" ? msg : "Não foi possível carregar os clientes" });
      });
    },
    carregarUsuarios(valor) {
      this.usuarioEscolhido = null;
      this.usuarios = [];
      const filtrado = valor && valor !== "todos";
      const params = {};
      if (filtrado) {
        const [cliente, dominio] = valor.split("|");
        params.cliente = cliente;
        params.dominio = dominio;
      }
      this.carregandoUsuarios = true;
      axios.get(`${baseApiUrl}/users/impersonate/usuarios`, { params })
        .then((res) => {
          this.usuarios = res.data.map((row) => {
            const tipo = this.tipoUsuarioLabel(row.tipoUsuario);
            const nome = titleCase(row.name || "");
            const lugar = titleCase(
              [row.cliente, row.dominio].filter(Boolean).join(" ").replace(/_/g, " ")
            );
            const banco = Number(row.tipoUsuario) === 1 ? this.bancoLabel(row.consignatario) : "";
            const detalhe = [tipo, banco, lugar].filter(Boolean).join(", ");
            return {
              value: row.id,
              text: detalhe ? `${nome} (${detalhe})` : nome,
            };
          });
        })
        .catch((error) => {
          const msg = error.response && error.response.data;
          this.$toasted.global.defaultError({ msg: typeof msg === "string" ? msg : "Não foi possível carregar os usuários" });
        })
        .finally(() => {
          this.carregandoUsuarios = false;
        });
    },
    aplicarSessao(data) {
      localStorage.setItem(userKey, JSON.stringify(data));
      this.$store.commit("setUser", data);
      window.location.href = "/";
    },
    entrar(id) {
      if (!id) return;
      axios.post(`${baseApiUrl}/users/impersonate`, { id })
        .then((res) => this.aplicarSessao(res.data))
        .catch((error) => {
          this.usuarioEscolhido = null;
          const msg = error.response && error.response.data;
          this.$toasted.global.defaultError({ msg: typeof msg === "string" ? msg : "Não foi possível entrar" });
        });
    },
    voltar() {
      axios.post(`${baseApiUrl}/users/impersonate/stop`)
        .then((res) => this.aplicarSessao(res.data))
        .catch((error) => {
          const msg = error.response && error.response.data;
          this.$toasted.global.defaultError({ msg: typeof msg === "string" ? msg : "Não foi possível voltar" });
        });
    },
  },
};
</script>

<style>
.modal.entrar-como-modal {
  z-index: 1050;
  background: transparent;
}

.modal-dialog.entrar-como-dialog {
  max-width: 80vw !important;
  width: 80vw !important;
}
</style>
